import MarkdownMessage from '@gluedigital/markdown-message';
import { ModalWrapper } from '@gluedigital/modal';
import { Suspense, useEffect, useState } from 'react';
import { useWidgetById } from 'src/hooks/api';
import { useIsMobile } from 'src/hooks/useIsMobile';
import { HomeLayout } from 'src/routes/Home/Home';
import { CustomPosition, setWidget } from 'src/store/actions/widget';
import { useAppDispatch } from 'universal-scripts';
import Chat from '../Chat/Chat';
import ErrorBoundary from '../ErrorBoundary/ErrorBoundary';
import { getPositionClassName, prepareStyle } from './utils/position';
import WidgetAvatar from './WidgetAvatar/WidgetAvatar';

import './Widget.sass';

const Widget = ({ id }: { id?: string }) => {
	const dispatch = useAppDispatch();
	const widget = useWidgetById(id);

	useEffect(() => {
		if (widget) dispatch(setWidget(widget));
	}, [dispatch, id, widget]);
	const [open, setOpen] = useState<boolean>(false);

	const position = widget?.position;
	const mobilePosition = position?.mobile;
	const desktopPosition = position?.desktop;

	const isMobile = useIsMobile();
	const mobilePositionClassName = getPositionClassName(mobilePosition);
	const desktopPositionClassName = getPositionClassName(desktopPosition);
	const mobilePositionStyle = !mobilePositionClassName.startsWith('custom') ? {} : prepareStyle(mobilePosition as CustomPosition);
	const desktopPositionStyle = !desktopPositionClassName.startsWith('custom') ? {} : prepareStyle(desktopPosition as CustomPosition);

	const themeStyle = widget?.themeColor
		? ({ '--widget-accent': widget.themeColor, '--widget-accent-dark': `${widget.themeColor}33` } as React.CSSProperties)
		: {};

	return (
		<div
			id="widget-chatbot"
			className={`${open ? 'widget-chatbot-open' : 'widget-chatbot-close'}
         ${isMobile ? mobilePositionClassName : desktopPositionClassName}`}
			onClick={() => open && setOpen(false)}
			style={themeStyle}
		>
			<div id="widget-bot-container" onClick={() => setOpen(!open)} style={isMobile ? mobilePositionStyle : desktopPositionStyle}>
				{open ? (
					<span className="icon icon-cross" />
				) : (
					<>
						<div id="widget-bot-bubble">
							<div id="widget-bubble-checks" />
							<div id="widget-bubble-text">
								<MarkdownMessage id="widget-chatbot.bubble-text" />
							</div>
						</div>
						<WidgetAvatar overrideSrc={widget?.botWidget} />
					</>
				)}
			</div>
			<dialog id="widget-dialog" open={open}>
				<ModalWrapper>
					<div id="root" onClick={(e) => e.stopPropagation()}>
						<main id="app">
							<HomeLayout>
								<Chat />
							</HomeLayout>
						</main>
					</div>
				</ModalWrapper>
			</dialog>
		</div>
	);
};

const WidgetWrapper = ({ id }: { id?: string }) => {
	return (
		<ErrorBoundary fallback="error">
			<Suspense fallback="loading">
				<Widget id={id} />
			</Suspense>
		</ErrorBoundary>
	);
};

export default WidgetWrapper;
